import { render, staticRenderFns } from "./Modal-content.vue?vue&type=template&id=3a1b475a&scoped=true&lang=pug"
import script from "./Modal-content.vue?vue&type=script&lang=js"
export * from "./Modal-content.vue?vue&type=script&lang=js"
import style0 from "./Modal-content.vue?vue&type=style&index=0&id=3a1b475a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1b475a",
  null
  
)

export default component.exports